import { render, staticRenderFns } from "./SKTable.vue?vue&type=template&id=1b8e0c5f&scoped=true&"
import script from "./SKTable.vue?vue&type=script&lang=js&"
export * from "./SKTable.vue?vue&type=script&lang=js&"
import style0 from "./SKTable.vue?vue&type=style&index=0&id=1b8e0c5f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8e0c5f",
  null
  
)

export default component.exports